(function () {
  "use strict";

  const HB_PREVIEW_CONFIGS = {
    default: {
      enabled: false
    },

    "borsa-juta-grande-personalizzabile": {
      enabled: true,

      title: "Crea la tua borsa dell'estate",
      subtitle: "Scegli nome, stile e fiocco: l'anteprima si aggiorna in tempo reale.",

      canvas: {
        width: 1000,
        height: 1000
      },

      baseImage: "hb-borsa-juta-grande.png",

      fields: {
        text: {
  type: "text",
  selectors: [
    'input[name="Nome o frase"]',
    'input[data-field-name="Nome o frase"]',
    'input[data-name="properties[Nome o frase]"]',

    'textarea[name="Nome o frase"]',
    'textarea[data-field-name="Nome o frase"]',
    'textarea[data-name="properties[Nome o frase]"]',

    'input[name="Nome o testo"]',
    'input[data-field-name="Nome o testo"]',
    'input[data-name="properties[Nome o testo]"]'
  ],
  placeholder: "Il tuo nome",
  maxLength: 40
},

        font: {
  type: "choice",
  selectors: [
    'input[name="Stile scritta"]:checked',
    'input[data-field-name="Stile scritta"]:checked',
    'input[data-name="properties[Stile scritta]"]:checked'
  ],
  default: "elegante",
  map: {
    "Elegante": "elegante",
    "Moderno": "moderno",
    "Vintage": "vintage",
    "Stile Elegante": "elegante",
    "Stile Moderno": "moderno",
    "Stile Vintage": "vintage"
  }
},

        textColor: {
          type: "choice",
          selectors: [
            'input[name="Colore scritta "]:checked',
            'input[data-field-name="Colore scritta "]:checked',
            'input[data-name="properties[Colore scritta ]"]:checked'
          ],
          default: "nero",
          map: {
  "Bianco": "bianco",
  "Nero": "nero",
  "Fucsia": "fucsia"
}
        },

        bow: {
          type: "choice",
          selectors: [
            'input[name="Fiocco"]:checked',
            'input[data-field-name="Fiocco"]:checked',
            'input[data-name="properties[Fiocco]"]:checked'
          ],
          default: "nero",
          map: {
  "Bianco": "bianco",
  "Nero": "nero",
  "Fucsia": "fucsia"
}
        }
      },

      colors: {
  nero: "#111111",
  bianco: "#f7f4ee",
  fucsia: "#DA3673"
},

      fonts: {
  elegante: "HBElegante, cursive",
  moderno: "HBModerno, Arial, Helvetica, sans-serif",
  vintage: "HBVintage, serif"
},

      areas: {
        text: {
          x: 226,
          y: 545,
          width: 562,
          height: 280,
          align: "center",
          baseline: "middle",
          rotation: 0
        },

        bow: {
          x: 153,
          y: 217,
          width: 403,
          height: 404
        }
      },

            textRules: {
        maxFontSize: {
          elegante: 85,
          moderno: 145,
          vintage: 110
        },
        minFontSize: 28,
        maxLines: 3,
        lineHeight: {
          elegante: 1.85,
          moderno: 1.28,
          vintage: 1.2
        },

        uppercaseFor: ["vintage"],
        capitalizeFirstFor: ["elegante", "moderno"],
        letterSpacing: {
          vintage: 0.14
        },
        fontLoadPreview: {
          elegante: '85px "HBElegante"',
          moderno: '145px "HBModerno"',
          vintage: '110px "HBVintage"'
        }
      },

      assets: {
        bows: {
  bianco: "hb-fiocco-bianco-v5.png",
  nero: "hb-fiocco-nero-v2.png",
  fucsia: "hb-fiocco-fucsia.png"
}
      },

      layers: [
        {
          id: "base",
          type: "image",
          source: "baseImage",
          fit: "contain"
        },
        {
          id: "text",
          type: "text",
          valueFrom: "text",
          fontFrom: "font",
          colorFrom: "textColor",
          area: "text"
        },
        {
          id: "bow",
          type: "image",
          assetGroup: "bows",
          valueFrom: "bow",
          area: "bow",
          fit: "contain"
        }
      ]
    }
  };

  const imageCache = new Map();

  document.addEventListener("DOMContentLoaded", initHbPreviews);
  document.addEventListener("shopify:section:load", initHbPreviews);

  function initHbPreviews() {
    const previews = document.querySelectorAll("[data-hb-preview]:not([data-hb-preview-ready])");

    previews.forEach(function (previewEl) {
      previewEl.setAttribute("data-hb-preview-ready", "true");
      createPreview(previewEl);
    });
  }

  function createPreview(previewEl) {
    const productData = readProductData(previewEl);
    const handle = productData.handle;
    const config = HB_PREVIEW_CONFIGS[handle] || HB_PREVIEW_CONFIGS.default;

    if (!config || !config.enabled) {
      previewEl.style.display = "none";
      return;
    }

    forcePreviewBeforeGlobo(previewEl);
    watchGloboPosition(previewEl);

    const canvas = previewEl.querySelector("[data-hb-preview-canvas]");
    const titleEl = previewEl.querySelector("[data-hb-preview-title]");
    const subtitleEl = previewEl.querySelector("[data-hb-preview-subtitle]");
    const noticeEl = previewEl.querySelector("[data-hb-preview-notice]");

    if (!canvas) return;

    const ctx = canvas.getContext("2d");
    const width = config.canvas && config.canvas.width ? config.canvas.width : 1000;
    const height = config.canvas && config.canvas.height ? config.canvas.height : 1000;

    canvas.width = width;
    canvas.height = height;

    if (titleEl) titleEl.textContent = config.title || "Anteprima personalizzazione";
    if (subtitleEl) subtitleEl.textContent = config.subtitle || "";

    const state = {
      previewEl: previewEl,
      canvas: canvas,
      ctx: ctx,
      config: config,
      productData: productData,
      noticeEl: noticeEl,
      assetsBaseUrl: previewEl.getAttribute("data-assets-base") || "",
      renderToken: 0,
      renderTimer: null
    };

    scheduleRender(state);

    document.addEventListener("input", function () {
      scheduleRender(state);
    });

    document.addEventListener("change", function () {
      scheduleRender(state);
    });

    document.addEventListener("click", function () {
      window.setTimeout(function () {
        scheduleRender(state);
      }, 80);
    });

    const observer = new MutationObserver(function () {
      scheduleRender(state);
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["class", "value", "checked", "selected", "aria-checked", "aria-pressed"]
    });
  }

  function scheduleRender(state) {
    window.clearTimeout(state.renderTimer);
    state.renderTimer = window.setTimeout(function () {
      renderPreview(state);
    }, 80);
  }

  async function renderPreview(state) {
    state.renderToken += 1;
    const currentRenderToken = state.renderToken;

    const config = state.config;
    const values = readAllFieldValues(config);

    clearCanvas(state.ctx, state.canvas);

    try {
      for (const layer of config.layers || []) {
        if (layer.type === "image") {
          await drawImageLayer(state, layer, values);
          if (currentRenderToken !== state.renderToken) return;
        }

        if (layer.type === "text") {
          await drawTextLayer(state, layer, values);
          if (currentRenderToken !== state.renderToken) return;
        }
      }

      if (currentRenderToken !== state.renderToken) return;

      state.previewEl.classList.add("is-ready");
      hideNotice(state);
    } catch (error) {
      console.warn("[HB Preview] Errore render:", error);
      state.previewEl.classList.add("is-ready");
      showNotice(state, "Anteprima caricata parzialmente. Controlla immagini, font e configurazione.");
    }
  }

  function clearCanvas(ctx, canvas) {
    ctx.clearRect(0, 0, canvas.width, canvas.height);
  }

  async function drawImageLayer(state, layer, values) {
    const config = state.config;
    let imageSource = "";

    if (layer.source === "baseImage") {
      imageSource = config.baseImage || state.productData.featuredImage;
    }

    if (layer.assetGroup && layer.valueFrom) {
      const fieldValue = values[layer.valueFrom] || "";
      if (!fieldValue) return;

      const group = config.assets && config.assets[layer.assetGroup];
      if (!group || !group[fieldValue]) return;

      imageSource = group[fieldValue];
    }

    if (!imageSource && state.productData.featuredImage) {
      imageSource = state.productData.featuredImage;
    }

    if (!imageSource) return;

    const url = resolveAssetUrl(imageSource, state.assetsBaseUrl);
    let image;

    try {
      image = await loadImage(url);
    } catch (error) {
      if (layer.source === "baseImage" && state.productData.featuredImage) {
        image = await loadImage(normalizeUrl(state.productData.featuredImage));
      } else {
        return;
      }
    }

    const area = layer.area && config.areas ? config.areas[layer.area] : {
      x: 0,
      y: 0,
      width: state.canvas.width,
      height: state.canvas.height
    };

    drawImageIntoArea(state.ctx, image, area, layer.fit || "contain");
  }

  function drawImageIntoArea(ctx, image, area, fit) {
    const box = normalizeArea(area);

    if (fit === "cover") {
      const scale = Math.max(box.width / image.width, box.height / image.height);
      const width = image.width * scale;
      const height = image.height * scale;
      const x = box.x + (box.width - width) / 2;
      const y = box.y + (box.height - height) / 2;
      ctx.drawImage(image, x, y, width, height);
      return;
    }

    const scale = Math.min(box.width / image.width, box.height / image.height);
    const width = image.width * scale;
    const height = image.height * scale;
    const x = box.x + (box.width - width) / 2;
    const y = box.y + (box.height - height) / 2;

    ctx.drawImage(image, x, y, width, height);
  }

  async function drawTextLayer(state, layer, values) {
    const config = state.config;
    const fieldConfig = config.fields && config.fields[layer.valueFrom];
    const rawText = values[layer.valueFrom] || fieldConfig?.placeholder || "";
    if (!rawText) return;

    const fontFieldConfig = config.fields && config.fields[layer.fontFrom];
    const fontKey = values[layer.fontFrom] || fontFieldConfig?.default || "elegante";
    const colorKey = values[layer.colorFrom] || "nero";
    const fontFamily = config.fonts && config.fonts[fontKey] ? config.fonts[fontKey] : "Arial, Helvetica, sans-serif";
    const fillColor = config.colors && config.colors[colorKey] ? config.colors[colorKey] : "#1f1f1f";
    const rules = config.textRules || {};
    const area = normalizeArea(config.areas[layer.area]);
    const ctx = state.ctx;

    let text = String(rawText).trim();
    if (shouldUppercaseFont(rules, fontKey)) {
      text = text.toUpperCase();
    } else if (shouldCapitalizeFirst(rules, fontKey)) {
      text = capitalizeFirstLetter(text);
    }

    await ensureFontReady(fontKey, rules);

    ctx.save();
    ctx.fillStyle = fillColor;
    ctx.textAlign = area.align || "center";
    ctx.textBaseline = "middle";

    const maxFontSize = resolveRuleValue(rules.maxFontSize, fontKey, 72);
    const minFontSize = resolveRuleValue(rules.minFontSize, fontKey, 24);
    const maxLines = resolveRuleValue(rules.maxLines, fontKey, 2);
    const lineHeight = resolveRuleValue(rules.lineHeight, fontKey, 1.15);
    const letterSpacingEm = Number(resolveRuleValue(rules.letterSpacing, fontKey, 0)) || 0;

    const fitted = fitText(ctx, text, fontFamily, area.width, area.height, {
      maxFontSize: maxFontSize,
      minFontSize: minFontSize,
      maxLines: maxLines,
      lineHeight: lineHeight,
      letterSpacing: letterSpacingEm
    });

    ctx.font = `${fitted.fontSize}px ${fontFamily}`;

    const centerX = area.x + area.width / 2;
    const centerY = area.y + area.height / 2;
    const rotation = area.rotation || 0;

    ctx.translate(centerX, centerY);
    ctx.rotate((rotation * Math.PI) / 180);

    const totalHeight = fitted.lines.length * fitted.fontSize * lineHeight;
    let startY = -totalHeight / 2 + (fitted.fontSize * lineHeight) / 2;

    const letterSpacingPx = fitted.fontSize * letterSpacingEm;

    fitted.lines.forEach(function (line, index) {
      const lineY = startY + index * fitted.fontSize * lineHeight;
      drawLine(ctx, line, 0, lineY, letterSpacingPx);
    });

    ctx.restore();
  }

  function drawLine(ctx, line, centerX, y, letterSpacing) {
    if (!letterSpacing) {
      ctx.fillText(line, centerX, y);
      return;
    }

    const chars = Array.from(String(line));
    if (chars.length === 0) return;

    const totalWidth = measureLineWidth(ctx, line, letterSpacing);
    const previousAlign = ctx.textAlign;

    ctx.textAlign = "left";

    let cursorX = centerX - totalWidth / 2;

    for (let i = 0; i < chars.length; i += 1) {
      const char = chars[i];
      ctx.fillText(char, cursorX, y);
      cursorX += ctx.measureText(char).width + letterSpacing;
    }

    ctx.textAlign = previousAlign;
  }

  function measureLineWidth(ctx, line, letterSpacing) {
    if (!letterSpacing) {
      return ctx.measureText(line).width;
    }

    const chars = Array.from(String(line));
    let width = 0;

    for (let i = 0; i < chars.length; i += 1) {
      width += ctx.measureText(chars[i]).width;
    }

    width += letterSpacing * Math.max(0, chars.length - 1);
    return width;
  }

  function fitText(ctx, text, fontFamily, maxWidth, maxHeight, options) {
    let fontSize = options.maxFontSize;
    const letterSpacingEm = options.letterSpacing || 0;

    while (fontSize >= options.minFontSize) {
      ctx.font = `${fontSize}px ${fontFamily}`;
      const spacingPx = fontSize * letterSpacingEm;
      const lines = wrapText(ctx, text, maxWidth, options.maxLines, spacingPx);
      const totalHeight = lines.length * fontSize * options.lineHeight;
      const widestLine = Math.max.apply(null, lines.map(function (line) {
        return measureLineWidth(ctx, line, spacingPx);
      }));

      if (widestLine <= maxWidth && totalHeight <= maxHeight && lines.length <= options.maxLines) {
        return {
          fontSize: fontSize,
          lines: lines
        };
      }

      fontSize -= 2;
    }

    ctx.font = `${options.minFontSize}px ${fontFamily}`;

    return {
      fontSize: options.minFontSize,
      lines: wrapText(ctx, text, maxWidth, options.maxLines, options.minFontSize * letterSpacingEm)
    };
  }

  function wrapText(ctx, text, maxWidth, maxLines, letterSpacing) {
    const spacing = letterSpacing || 0;
    const words = String(text).split(/\s+/).filter(Boolean);
    if (words.length === 0) return [""];

    const lines = [];
    let currentLine = "";
    const cap = Number(maxLines) > 0 ? Number(maxLines) : Infinity;

    for (let i = 0; i < words.length; i += 1) {
      const word = words[i];
      const testLine = currentLine ? `${currentLine} ${word}` : word;
      const width = measureLineWidth(ctx, testLine, spacing);

      if (width <= maxWidth || !currentLine) {
        currentLine = testLine;
      } else {
        if (lines.length + 1 >= cap) {
          const remaining = words.slice(i).join(" ");
          currentLine = `${currentLine} ${remaining}`;
          break;
        }

        lines.push(currentLine);
        currentLine = word;
      }
    }

    if (currentLine) lines.push(currentLine);

    return lines.slice(0, cap);
  }

  function readAllFieldValues(config) {
    const values = {};

    Object.keys(config.fields || {}).forEach(function (key) {
      const fieldConfig = config.fields[key];
      const rawValue = readFieldValue(fieldConfig);
      let mappedValue = mapFieldValue(rawValue, fieldConfig);

      if (fieldConfig.type === "text" && fieldConfig.maxLength) {
        mappedValue = String(mappedValue || "").slice(0, Number(fieldConfig.maxLength));
      }

      values[key] = mappedValue;
    });

    return values;
  }

  function readFieldValue(fieldConfig) {
    if (!fieldConfig) return "";

    if (Array.isArray(fieldConfig.selectors)) {
      for (const selector of fieldConfig.selectors) {
        const el = document.querySelector(selector);
        const value = getElementValue(el);
        if (value) return value;
      }
    }

    return fieldConfig.default || "";
  }

  function getElementValue(el) {
    if (!el) return "";

    const tag = el.tagName ? el.tagName.toLowerCase() : "";

    if (tag === "select") {
      const selected = el.options && el.options[el.selectedIndex];
      return cleanValue(selected ? selected.textContent || selected.value : el.value);
    }

    if (tag === "textarea") {
      return cleanValue(el.value);
    }

    if (tag === "input") {
      const type = (el.type || "").toLowerCase();

      if (type === "radio" || type === "checkbox") {
        if (!el.checked) return "";
        return cleanValue(el.value);
      }

      return cleanValue(el.value);
    }

    return cleanValue(el.textContent || "");
  }

  function mapFieldValue(rawValue, fieldConfig) {
    const raw = cleanValue(rawValue);

    if (!raw) return fieldConfig.default || "";
    if (!fieldConfig.map) return raw;

    const normalizedRaw = normalizeText(raw);

    for (const originalLabel in fieldConfig.map) {
      if (normalizeText(originalLabel) === normalizedRaw) {
        return fieldConfig.map[originalLabel];
      }

      if (normalizeText(fieldConfig.map[originalLabel]) === normalizedRaw) {
        return fieldConfig.map[originalLabel];
      }
    }

    return fieldConfig.default || raw;
  }

  function readProductData(previewEl) {
    const script = previewEl.querySelector("[data-hb-product-data]");

    if (!script) {
      return {
        handle: previewEl.getAttribute("data-product-handle") || "",
        featuredImage: ""
      };
    }

    try {
      return JSON.parse(script.textContent);
    } catch (error) {
      return {
        handle: previewEl.getAttribute("data-product-handle") || "",
        featuredImage: ""
      };
    }
  }

  function resolveAssetUrl(source, assetsBaseUrl) {
    if (!source) return "";
    if (/^https?:\/\//i.test(source)) return source;
    if (/^\/\//.test(source)) return window.location.protocol + source;
    if (/^\//.test(source)) return source;
    return assetsBaseUrl + source;
  }

  function normalizeUrl(url) {
    if (!url) return "";
    if (/^\/\//.test(url)) return window.location.protocol + url;
    return url;
  }

  function loadImage(url) {
    const normalizedUrl = normalizeUrl(url);

    if (imageCache.has(normalizedUrl)) {
      return imageCache.get(normalizedUrl);
    }

    const promise = new Promise(function (resolve, reject) {
      const image = new Image();
      image.crossOrigin = "anonymous";
      image.onload = function () {
        resolve(image);
      };
      image.onerror = reject;
      image.src = normalizedUrl;
    });

    imageCache.set(normalizedUrl, promise);
    return promise;
  }

  async function ensureFontReady(fontKey, rules) {
    if (!document.fonts || !document.fonts.load) return;

    const previewValue = resolveRuleValue(rules.fontLoadPreview, fontKey, "");
    if (!previewValue) return;

    try {
      await document.fonts.load(previewValue);
    } catch (error) {
      console.warn("[HB Preview] Font non pronto:", fontKey, error);
    }
  }

  function normalizeArea(area) {
    return {
      x: Number(area?.x || 0),
      y: Number(area?.y || 0),
      width: Number(area?.width || 1000),
      height: Number(area?.height || 1000),
      align: area?.align || "center",
      baseline: area?.baseline || "middle",
      rotation: Number(area?.rotation || 0)
    };
  }

  function resolveRuleValue(ruleValue, fontKey, fallback) {
    if (ruleValue && typeof ruleValue === "object" && !Array.isArray(ruleValue)) {
      if (Object.prototype.hasOwnProperty.call(ruleValue, fontKey)) return ruleValue[fontKey];
      if (Object.prototype.hasOwnProperty.call(ruleValue, "default")) return ruleValue.default;
    }

    return typeof ruleValue === "undefined" ? fallback : ruleValue;
  }

  function shouldUppercaseFont(rules, fontKey) {
    if (Array.isArray(rules.uppercaseFor)) {
      return rules.uppercaseFor.indexOf(fontKey) !== -1;
    }

    if (rules.uppercaseForStampatello && fontKey === "stampatello") {
      return true;
    }

    return false;
  }

  function shouldCapitalizeFirst(rules, fontKey) {
    return Array.isArray(rules.capitalizeFirstFor) && rules.capitalizeFirstFor.indexOf(fontKey) !== -1;
  }

  function capitalizeFirstLetter(text) {
    const chars = Array.from(String(text || ""));
    if (chars.length === 0) return "";

    for (let i = 0; i < chars.length; i += 1) {
      const char = chars[i];

      // Salta eventuali spazi/numeri/simboli iniziali e maiuscola la prima vera lettera.
      if (char.toLowerCase() !== char.toUpperCase()) {
        chars[i] = char.toUpperCase();
        break;
      }
    }

    return chars.join("");
  }

  function cleanValue(value) {
    return String(value || "").replace(/\s+/g, " ").trim();
  }

  function normalizeText(value) {
    return cleanValue(value)
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[^\w\s]/g, "")
      .trim();
  }

  function showNotice(state, message) {
    if (!state.noticeEl) return;
    state.noticeEl.textContent = message;
    state.previewEl.classList.add("has-notice");
  }

  function hideNotice(state) {
    if (!state.noticeEl) return;
    state.noticeEl.textContent = "";
    state.previewEl.classList.remove("has-notice");
  }

  function forcePreviewBeforeGlobo(previewEl) {
    if (!previewEl) return;

    const shouldForce = previewEl.getAttribute("data-hb-force-before-globo") === "true";
    if (!shouldForce) return;

    const globoEl = findGloboElement(previewEl);
    if (!globoEl || !globoEl.parentNode) return;
    if (globoEl.previousElementSibling === previewEl) return;

    globoEl.parentNode.insertBefore(previewEl, globoEl);
  }

  function watchGloboPosition(previewEl) {
    if (!previewEl) return;

    const shouldForce = previewEl.getAttribute("data-hb-force-before-globo") === "true";
    if (!shouldForce) return;

    forcePreviewBeforeGlobo(previewEl);

    window.setTimeout(function () { forcePreviewBeforeGlobo(previewEl); }, 300);
    window.setTimeout(function () { forcePreviewBeforeGlobo(previewEl); }, 900);
    window.setTimeout(function () { forcePreviewBeforeGlobo(previewEl); }, 1800);

    const positionObserver = new MutationObserver(function () {
      forcePreviewBeforeGlobo(previewEl);
    });

    positionObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  function findGloboElement(previewEl) {
    const selectors = [
      ".gpo-app",
      ".gpo-container",
      ".globo-formbuilder",
      ".globo-form-control",
      "[id*='globo']",
      "[class*='globo']",
      "[id*='gpo']",
      "[class*='gpo']"
    ];

    for (const selector of selectors) {
      const elements = Array.from(document.querySelectorAll(selector));

      for (const el of elements) {
        if (!el) continue;
        if (el === previewEl) continue;
        if (previewEl.contains(el)) continue;
        if (el.closest("[data-hb-preview]")) continue;

        const text = (el.textContent || "").toLowerCase();
        const hasInputs = el.querySelector("input, select, textarea");

        if (hasInputs || text.includes("nome") || text.includes("fiocco") || text.includes("personalizzazione")) {
          return el;
        }
      }
    }

    return null;
  }
})();